export default __webpack_public_path__ + "static/media/inwardLetter.eea0085c.png";